import RemoveMultiplierModal from './RemoveMultiplierModal.component';

export default RemoveMultiplierModal;
